<template>
  <div class="t-message">{{ message }}</div>
</template>

<script>
export default {
  name: 'toast',
  data() {
    return {
      message: '',
      // 显示时间，默认为2000
      duration: 2000,
    };
  },
  mounted() {
    // 指定时间后销毁组件
    setTimeout(() => {
      this.$destroy(true); // 销毁组件
      this.$el.parentNode.removeChild(this.$el); // 父元素中移除dom元素（$el为组件实例）
    }, this.duration);
  },
};
</script>

<style lang="less" scoped>
.t-message {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
  transition: all 0.3s;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 2px;
  padding: 0 42px;
  font-size: 14px;
  z-index: 999999;
  color: #ffffff;
}
</style>
